import gql from 'graphql-tag';

export default gql`
    query($organizationId: String!, $from: String, $to: String) {
        depositsStats(organizationId: $organizationId, from: $from, to: $to) {
            currencyId
            networkId
            amount
            length
            createdAt
        }
    }
`;